import { render, staticRenderFns } from "./modal_language_certificate_form.vue?vue&type=template&id=b8bf4844"
import script from "./modal_language_certificate_form.vue?vue&type=script&lang=js"
export * from "./modal_language_certificate_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports